/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Box, Snackbar, Link } from '@mui/material'
// import { FiAlertTriangle } from 'react-icons/fi'
import { useShallow } from 'zustand/react/shallow'

// Stores
import { useChatStore } from '../../stores/useChatStore'
import { useUIStore } from '../../stores/useUIStore'
import { useArcanoStore } from '../../stores/useArcanoStore'

// Hooks
import { useAuthContext } from '../../contexts/AuthContext'
import { useConversationManagement } from '../../hooks/useConversationManagement'

// Components
import ChatHeader from '../../components/ChatPage/ChatHeader'
import MessageList from '../../components/ChatPage/MessageList'
import ChatInput from '../../components/ChatPage/ChatInput'
import ChangelogModal from '../../components/ChatPage/ChangelogModal'

// Services
import { getAppVersion } from '../../services/versionService'

import './ChatPage.css'
import { FiAlertTriangle } from 'react-icons/fi'

const ChatPage = () => {
  const [changelogOpen, setChangelogOpen] = useState(false)
  const { token, loading: authLoading } = useAuthContext()

  const conversationManagement = useConversationManagement()

  const { searchQuery, error, clearError } = useChatStore(
    useShallow(state => ({
      searchQuery: state.searchQuery,
      error: state.error,
      clearError: state.clearError,
    }))
  )

  const { appVersion, snackbar, setAppVersion, hideSnackbar } = useUIStore(
    useShallow(state => ({
      appVersion: state.appVersion,
      snackbar: state.snackbar,
      setAppVersion: state.setAppVersion,
      hideSnackbar: state.hideSnackbar,
    }))
  )

  const { selectedArcano, selectedProject } = useArcanoStore(
    useShallow(state => ({
      selectedArcano: state.selectedArcano,
      selectedProject: state.selectedProject,
    }))
  )

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const version = await getAppVersion()
        setAppVersion(version)
      } catch (error) {
        console.error('Failed to fetch app version:', error)
      }
    }
    fetchVersion()
  }, [setAppVersion])

  useEffect(() => {
    if (token && !authLoading) {
      conversationManagement.initializeConversations()
    }
  }, [token, authLoading])

  useEffect(() => {
    if (token && !authLoading && useArcanoStore.getState().arcanoRestorationComplete) {
      const timeoutId = setTimeout(() => {
        conversationManagement.fetchConversations()
      }, 300)
      return () => clearTimeout(timeoutId)
    }
  }, [token, authLoading, searchQuery, selectedArcano, selectedProject])

  if (authLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <p>Inizializzazione di F.R.A.N.C.A....</p>
      </div>
    )
  }

  return (
    <>
      <Box className="chat-area">
        <ChatHeader />
        {error && (
          <>
            <Box onClick={() => clearError('')} className="error-banner">
              <FiAlertTriangle />
              <span>{error}</span>
            </Box>
          </>
        )}
        <MessageList />
        <ChatInput />
        <Box className="app-footer-info">
          <p>
            FRANCA AI può commettere errori. Qualsiasi feedback può essere inviato a{' '}
            <a href="mailto:itjunior@sfre.it">itjunior@sfre.it</a>. Versione {appVersion}{' '}
            ·{' '}
            <Link
              component="button"
              variant="body2"
              onClick={() => setChangelogOpen(true)}
              sx={{
                fontSize: 'inherit',
                color: 'inherit',
                textDecoration: 'underline',
                cursor: 'pointer',
                p: 0,
                border: 'none',
                background: 'none',
                font: 'inherit',
              }}
            >
              Changelog
            </Link>
            {' '}
            · Abilita Deepthink per attività avanzate.
          </p>
        </Box>
        <ChangelogModal open={changelogOpen} onClose={() => setChangelogOpen(false)} />
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={hideSnackbar}
        message={snackbar.message}
        anchorOrigin={{
          vertical: snackbar.vertical,
          horizontal: snackbar.horizontal,
        }}
      />
    </>
  )
}

export default ChatPage
